export const BATCH_SIZE = 100

function yieldToUI() {
  return new Promise(resolve => {
    requestAnimationFrame(() => setTimeout(resolve, 0))
  })
}

export async function buildRowsInBatches(datas, buildRow, onProgress) {
  const rows = []
  const total = datas.length

  if (onProgress) {
    onProgress(0, total)
    await yieldToUI()
  }

  for (let i = 0; i < total; i++) {
    rows.push(buildRow(datas[i]))
    if ((i + 1) % BATCH_SIZE === 0 || i === total - 1) {
      if (onProgress) onProgress(i + 1, total)
      await yieldToUI()
    }
  }

  return rows
}
